import {
  BinderCostRecordDto,
  useBinderCostRecordQuery
} from 'providers/api';
import React from 'react';
import { UseQueryResult } from 'react-query';
import { EditBinderCostRecordPageParams } from './constants';

export type EditBinderCostRecordQueries = [
  UseQueryResult<BinderCostRecordDto>
]

const useEditBinderCostRecordQueries = (params: EditBinderCostRecordPageParams): EditBinderCostRecordQueries => {
  const [binderCostRecord, setBinderCostRecord] = React.useState<BinderCostRecordDto | null>(null);

  const query = useBinderCostRecordQuery(
    params.binderCostRecord,
    {
      enabled: !binderCostRecord,
      cacheTime: 0,
    },
  );

  const { data, isFetched } = query;

  React.useEffect(() => {
    if (data && isFetched && !binderCostRecord) {
      setBinderCostRecord(data);
    }
  }, [data, binderCostRecord, isFetched]);

  return [query];
};

export default useEditBinderCostRecordQueries;
